import { Col, Row } from "react-bootstrap";
import SiteEnergySource from "../../../../../../shared/components/site-energy-source/site-energy-source";
import EnergyFlowImg from "../../../../../../shared/oversight-core/assets/images/good-we-energy-flow-center.svg";
import { IGoodWeSolarPlantView } from "../../../../../../shared/oversight-core/interfaces/good-we-solar-plant-view";
import Helper from "../../../../../../shared/oversight-core/utils/helpers";
import translate from "../../../../../../shared/oversight-core/utils/translate";
import EnergyFlowNode from "../components/energy-flow-node/energy-flow-node";
import EnergyFlowPath from "../components/energy-flow-path/energy-flow-path";
import styles from "./energy-flow.module.scss";

interface IProps {
  solarPlant: IGoodWeSolarPlantView;
}

const chartData: { value: number }[] = [
  { value: 100 },
  { value: 130 },
  { value: 210 },
  { value: 190 },
  { value: 240 },
  { value: 300 },
  { value: 220 },
  { value: 240 },
  { value: 190 },
  { value: 230 },
];

const GoodWeEnergyFlow = (props: IProps) => {
  const { solarPlant } = props;

  return (
    <div className={styles.goodWeEnergyFlowContainer}>
      <EnergyFlowNode
        x={315}
        y={0}
        title="Grid"
        value={
          solarPlant?.pmeter_power
            ? `${Number(Helper.roundTo2(solarPlant?.pmeter_power))} W`
            : ``
        }
        icon="flash_on"
        iconColor="#3E6E8C"
        iconBgColor="#EEF6F8"
        siteEnergySource={
          <SiteEnergySource
            data={chartData}
            stopColor="#29B4CC14"
            stroke="#299BCC80"
            id="colorUv"
          />
        }
        hideArrowIcon
      />
      <EnergyFlowNode
        x={0}
        y={450}
        title={translate(solarPlant?.batteryStatus)}
        value={solarPlant?.battery_soc ? `${solarPlant?.battery_soc} %` : ``}
        value2={
          solarPlant?.battery_power ? `${solarPlant?.battery_power} kWh` : ``
        }
        icon="battery_charging_80"
        iconColor="#5E45B8"
        iconBgColor="#EFEEF8"
        siteEnergySource={
          <SiteEnergySource
            data={chartData}
            stopColor="#4C29CC14"
            stroke="#4C29CC59"
            id="colorUx"
          />
        }
        hideArrowIcon
      />
      <EnergyFlowNode
        x={315}
        y={450}
        title="PV Inverter"
        value={
          solarPlant?.pv_power
            ? `${Number(Helper.roundTo2(solarPlant?.pv_power))} W`
            : ``
        }
        icon="light_mode"
        iconColor="#D08700"
        iconBgColor="#F9F0E0"
        siteEnergySource={
          <SiteEnergySource
            data={chartData}
            stopColor="#D0870014"
            stroke="#D0870080"
            id="colorUc"
          />
        }
        hideArrowIcon
      />
      <EnergyFlowNode
        x={640}
        y={230}
        title="Load"
        value={
          solarPlant?.load_power
            ? `${Number(Helper.roundTo2(solarPlant?.load_power))} W`
            : ``
        }
        icon="smart_outlet"
        iconColor="#E45151"
        iconBgColor="#FAF4F4"
        siteEnergySource={
          <SiteEnergySource
            data={chartData}
            stopColor="#E4515114"
            stroke="#E4515180"
            id="colorUq"
          />
        }
        hideArrowIcon
      />
      <EnergyFlowPath // Grid path
        x={395}
        y={90}
        direction={solarPlant?.pmeter_power < 0 ? `up` : `down`}
        isActive={
          solarPlant?.pmeter_power ? solarPlant?.pmeter_power !== 0 : false
        }
        d={`m 55 0 l 0 200`}
      />
      <EnergyFlowPath // Battery path
        x={70}
        y={475}
        direction={solarPlant.battery_power < 0 ? `up` : `down`}
        isActive={
          solarPlant.battery_power ? solarPlant.battery_power !== 0 : false
        }
        d={`m 57 0 l 0 -60 l 320 0`}
      />
      <EnergyFlowPath // PV Inverter path
        x={395}
        y={421}
        direction={solarPlant.pv_power > 0 ? `up` : `down`}
        isActive={solarPlant.pv_power ? solarPlant.pv_power !== 0 : false}
        d={`m 55 -5 l 0 50`}
      />
      <EnergyFlowPath // PV Inverter and Battery Common path
        x={395}
        y={300}
        direction={
          solarPlant.pv_power > 0 ||
          (!solarPlant.pv_power && solarPlant.battery_power < 0)
            ? `up`
            : `down`
        }
        isActive={
          solarPlant.pv_power
            ? solarPlant.pv_power !== 0
            : false || solarPlant.battery_power
            ? solarPlant.battery_power !== 0
            : false
        }
        d={`m 55 0 l 0 114`}
      />
      <EnergyFlowPath // Load path
        x={400}
        y={300}
        direction={solarPlant.load_power < 0 ? `up` : `down`}
        isActive={solarPlant.load_power ? solarPlant.load_power !== 0 : false}
        d={`m 85 0 l 0 0 l 170 0`}
      />
      <div
        className="position-absolute"
        style={{ left: 398 + "px", top: 240 + "px" }}
      >
        <Row className={`${styles.energyFlowCenterTop} mx-0`}>
          <Col className="text-center">
            <img src={EnergyFlowImg} alt="Energy Flow" />
          </Col>
        </Row>
        <Row className={`${styles.energyFlowCenterBottom} mx-0`}>
          <Col className="text-center text-primary font-weight-400 font-size-12">
            {solarPlant.plantStatus ? translate(solarPlant.plantStatus) : ""}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default GoodWeEnergyFlow;
